import { render } from "./ButtonNavBar.vue?vue&type=template&id=112bc69a"
import script from "./ButtonNavBar.vue?vue&type=script&lang=js"
export * from "./ButtonNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__